{
  "header": "Деталі активу",
  "subtitle": "Актив, прикріплений до вашої вантажівки (причіп, контейнер тощо).",
  "assetType": "Тип активу",
  "assetTypePlaceholder": "Виберіть тип активу",
  "assetId": "ID активу (наприклад, номер причепа)",
  "assetIdPlaceholder": "Напр.: номер причепа, ID контейнера тощо",
  "remove": "Видалити",
  "addAnother": "Додати ще актив",
  "trailerType": "Тип причепа",
  "trailerId": "ID причепа"
}
